export default __webpack_public_path__ + "static/media/dropdown.6cc8bfd8.svg";